import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'filterZero'
})
export class FilterZeroPipe implements PipeTransform {
  transform(string: any): any {
    if (!string) return null;
    if (parseInt(string) == 0) return null;
    return string;
  }
}
